/* eslint-disable */

<template>
  <div class="vx-col">
    <vx-card class="mb-base">
      <div class="w-full flex justify-center relative click-item-container">
        <div class="image-container flex items-center" style="position: relative">
          <img
            src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/lines.png"
            draggable="false"
            style="width: 100%; height: 100%"
          />

          <button
            class="absolute top-20 bg-dark text-white main-border p-8 rounded-lg w-48 h-48 text-4xl font-bold"
            style="left: -5.9rem"
            @click="helpActive = !helpActive"
          >
            <font-awesome-icon icon="fa-regular fa-cloud" class="h-24 w-24" style="color: #ffc600" />
            VPC
          </button>

          <button
            class="absolute top-20 bg-dark text-white text-4xl font-bold main-border p-8 rounded-lg w-48 h-48"
            style="right: -5.9rem"
            @click="helpActive = !helpActive"
          >
            <font-awesome-icon icon="fa-solid fa-globe" class="h-24 w-24" style="color: #ffc600" />
            WAN
          </button>

          <span
            class="absolute flex items-center justify-center cursor-pointer"
            style="width: 5.5rem; height: 5rem; right: 36.7%; top: -2.5rem"
            @click="componentSelectingIndex = 0"
          >
            <font-awesome-icon
              :icon="getIconForComponentAnswer(components[0].value)"
              class="h-10 w-10 absolute"
              :style="{
                color: components[0].score === true ? '#30b851' : components[0].score === false ? '#c93738' : '#ffc600',
                zIndex: 10,
              }"
            />

            <img
              src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/hexagon.webp"
              draggable="false"
              class="w-full h-full absolute"
            />
          </span>

          <span
            class="absolute flex items-center justify-center cursor-pointer"
            style="width: 5.5rem; height: 5rem; right: 36.7%; top: 15.4rem"
            @click="componentSelectingIndex = 3"
          >
            <font-awesome-icon
              :icon="getIconForComponentAnswer(components[3].value)"
              class="h-10 w-10 absolute"
              :style="{
                color: components[3].score === true ? '#30b851' : components[3].score === false ? '#c93738' : '#ffc600',
                zIndex: 10,
              }"
            />

            <img
              src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/hexagon.webp"
              draggable="false"
              class="w-full h-full absolute"
            />
          </span>

          <!-- SUBNET ONE -->
          <div
            class="absolute flex items-center bg-dark text-white font-bold main-border p-8 rounded-lg w-3/4 h-40"
            style="left: 9rem; top: 5rem"
          >
            <div class="flex flex-col w-1/2">
              <span class="flex items-center gap-3">
                Subnet Type

                <small v-if="subnets[0].score !== null && subnets[0].score === false" class="text-danger font-semibold">Incorrect</small>
                <small v-else-if="subnets[0].score !== null && subnets[0].score === true" class="text-success font-semibold"
                  >Correct!</small
                >
              </span>
              <v-select :options="subnetOptions" v-model="subnets[0].value" class="w-64 popup-dropdown" placeholder="Select Subnet" />
            </div>
            <div class="flex relative w-1/2">
              <span
                class="absolute relative flex items-center justify-center cursor-pointer"
                style="width: 5.5rem; height: 5rem; left: -4.1rem"
                @click="componentSelectingIndex = 1"
              >
                <font-awesome-icon
                  :icon="getIconForComponentAnswer(components[1].value)"
                  class="h-10 w-10 absolute"
                  :style="{
                    color: components[1].score === true ? '#30b851' : components[1].score === false ? '#c93738' : '#ffc600',
                    zIndex: 10,
                  }"
                />

                <img
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/hexagon.webp"
                  draggable="false"
                  class="w-full h-full absolute"
                />
              </span>

              <span
                class="absolute relative flex items-center justify-center cursor-pointer"
                style="width: 5.5rem; height: 5rem; right: -7.5rem"
                @click="componentSelectingIndex = 2"
              >
                <font-awesome-icon
                  :icon="getIconForComponentAnswer(components[2].value)"
                  class="h-10 w-10 absolute"
                  :style="{
                    color: components[2].score === true ? '#30b851' : components[2].score === false ? '#c93738' : '#ffc600',
                    zIndex: 10,
                  }"
                />

                <img
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/hexagon.webp"
                  draggable="false"
                  class="w-full h-full absolute"
                />
              </span>
            </div>
          </div>

          <!-- SUBNET TWO -->
          <div
            class="absolute flex items-center bg-dark text-white font-bold main-border p-8 rounded-lg w-3/4 h-40"
            style="left: 9rem; bottom: 13rem"
          >
            <div class="flex flex-col w-1/2">
              <span class="flex items-center gap-3">
                Subnet Type

                <small v-if="subnets[1].score !== null && subnets[1].score === false" class="text-danger font-semibold">Incorrrect</small>
                <small v-else-if="subnets[1].score !== null && subnets[1].score === true" class="text-success font-semibold"
                  >Correct!</small
                >
              </span>
              <v-select :options="subnetOptions" v-model="subnets[1].value" class="w-64 popup-dropdown" placeholder="Select Subnet" />
            </div>
            <div class="flex relative w-1/2">
              <span
                class="absolute relative flex items-center justify-center cursor-pointer"
                style="width: 5.5rem; height: 5rem; left: -4.1rem"
                @click="componentSelectingIndex = 4"
              >
                <font-awesome-icon
                  :icon="getIconForComponentAnswer(components[4].value)"
                  class="h-10 w-10 absolute"
                  :style="{
                    color: components[4].score === true ? '#30b851' : components[4].score === false ? '#c93738' : '#ffc600',
                    zIndex: 10,
                  }"
                />

                <img
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/hexagon.webp"
                  draggable="false"
                  class="w-full h-full absolute"
                />
              </span>

              <span
                class="absolute relative flex items-center justify-center cursor-pointer"
                style="width: 5.5rem; height: 5rem; left: -1.1rem"
                @click="componentSelectingIndex = 5"
              >
                <font-awesome-icon
                  :icon="getIconForComponentAnswer(components[5].value)"
                  class="h-10 w-10 absolute"
                  :style="{
                    color: components[5].score === true ? '#30b851' : components[5].score === false ? '#c93738' : '#ffc600',
                    zIndex: 10,
                  }"
                />

                <img
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/hexagon.webp"
                  draggable="false"
                  class="w-full h-full absolute"
                />
              </span>

              <span
                class="absolute relative flex items-center justify-center cursor-pointer"
                style="width: 5.5rem; height: 5rem; right: -2rem"
                @click="componentSelectingIndex = 6"
              >
                <font-awesome-icon
                  :icon="getIconForComponentAnswer(components[6].value)"
                  class="h-10 w-10 absolute"
                  :style="{
                    color: components[6].score === true ? '#30b851' : components[6].score === false ? '#c93738' : '#ffc600',
                    zIndex: 10,
                  }"
                />

                <img
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/hexagon.webp"
                  draggable="false"
                  class="w-full h-full absolute"
                />
              </span>
            </div>
          </div>

          <!-- SUBNET THREE -->
          <div
            class="absolute flex items-center bg-dark text-white font-bold main-border p-8 rounded-lg w-3/4 h-40"
            style="left: 9rem; bottom: 2rem"
          >
            <div class="flex flex-col w-1/2">
              <span class="flex items-center gap-3">
                Subnet Type

                <small v-if="subnets[2].score !== null && subnets[2].score === false" class="text-danger font-semibold">Incorrect</small>
                <small v-else-if="subnets[2].score !== null && subnets[2].score === true" class="text-success font-semibold"
                  >Correct!</small
                >
              </span>
              <v-select :options="subnetOptions" v-model="subnets[2].value" class="w-64 popup-dropdown" placeholder="Select Subnet" />
            </div>
            <div class="flex relative w-1/2">
              <span
                class="absolute relative flex items-center justify-center cursor-pointer"
                style="width: 5.5rem; height: 5rem; right: -4.5rem"
                @click="componentSelectingIndex = 7"
              >
                <font-awesome-icon
                  :icon="getIconForComponentAnswer(components[7].value)"
                  class="h-10 w-10 absolute"
                  :style="{
                    color: components[7].score === true ? '#30b851' : components[7].score === false ? '#c93738' : '#ffc600',
                    zIndex: 10,
                  }"
                />

                <img
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02629971459187702498054/hexagon.webp"
                  draggable="false"
                  class="w-full h-full absolute"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <movable-popup
      refVal="componentSelectorPopup"
      title="Diagram Components"
      :active="componentSelectingIndex !== -1"
      v-on:close="componentSelectingIndex = -1"
      style="width: fit-content"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-3">
          <button
            v-for="(icon, index) in icons"
            :key="index"
            class="bg-dark flex items-center text-white font-semibold text-xl gap-4 main-border p-4 w-full h-fit cursor-pointer"
            @click="
              () => {
                components[componentSelectingIndex].value = icon.name;
                components[componentSelectingIndex].score = null;
                componentSelectingIndex = -1;
              }
            "
          >
            <font-awesome-icon :icon="icon.icon" class="h-8 w-8" style="color: #ffc600" />
            {{ icon.name }}
          </button>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';
import LottieAnimation from '../../../../../../../../components/lottie/LottieAnimation';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      subnetOptions: ['Public Subnet', 'Private Subnet'],
      componentSelectingIndex: -1,

      subnets: [
        {
          value: '',
          answer: 'Public Subnet',
          score: null,
        },
        {
          value: '',
          answer: 'Private Subnet',
          score: null,
        },
        {
          value: '',
          answer: 'Private Subnet',
          score: null,
        },
      ],

      icons: [
        {
          name: 'WAF',
          icon: 'fa-solid fa-block-brick-fire',
        },
        {
          name: 'AUTOSCALING INSTANCE',
          icon: 'fa-solid fa-network-wired',
        },
        {
          name: 'LOAD BALANCER',
          icon: 'fa-solid fa-scale-balanced',
        },
        {
          name: 'INSTANCE',
          icon: 'fa-solid fa-server',
        },
        {
          name: 'DATABASE',
          icon: 'fa-solid fa-database',
        },
      ],

      // Indexed starting at 0 from the top component to the bottom component going left to right
      components: [
        {
          value: '',
          answer: 'WAF',
          score: null,
        },
        {
          value: '',
          answer: 'AUTOSCALING INSTANCE',
          score: null,
        },
        {
          value: '',
          answer: 'AUTOSCALING INSTANCE',
          score: null,
        },
        {
          value: '',
          answer: 'LOAD BALANCER',
          score: null,
        },
        {
          value: '',
          answer: 'INSTANCE',
          score: null,
        },
        {
          value: '',
          answer: 'INSTANCE',
          score: null,
        },
        {
          value: '',
          answer: 'INSTANCE',
          score: null,
        },
        {
          value: '',
          answer: 'DATABASE',
          score: null,
        },
      ],
    };
  },
  methods: {
    getIconForComponentAnswer(answer) {
      const iconObject = this.icons.find((icon) => icon.name === answer);
      return iconObject ? iconObject.icon : 'fa-solid fa-plus';
    },
    markSimulation() {
      let total_score = 0;

      this.subnets.forEach((field, index) => {
        if (field.value === field.answer) {
          this.subnets[index].score = true;
          total_score++;
        } else {
          this.subnets[index].score = false;
        }
      });

      this.components.forEach((field, index) => {
        if (field.value === field.answer) {
          this.components[index].score = true;
          total_score++;
        } else {
          this.components[index].score = false;
        }
      });

      if (total_score === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', total_score);
      }

      this.$emit('simulation_getting_there', total_score);
    },
  },
  components: {
    Prism,
    vSelect,
    MovablePopup,
    LottieAnimation,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
